// Theme: light is the default; dark is a toggle. The choice lives in
// localStorage for instant paint (index.html reads it before React mounts)
// and is mirrored to the daemon's settings so a new device follows it.

export type Theme = 'light' | 'dark';

const KEY = 'ops-theme';
const COLORS: Record<Theme, string> = { light: '#f8fafc', dark: '#0c1118' };

export function currentTheme(): Theme {
  try {
    return localStorage.getItem(KEY) === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}

export function applyTheme(theme: Theme) {
  if (theme === 'dark') document.documentElement.dataset.theme = 'dark';
  else delete document.documentElement.dataset.theme;
  try {
    localStorage.setItem(KEY, theme);
  } catch {
    // private mode; the in-page state still applies
  }
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', COLORS[theme]);
}
